"use client";

import { useTranslation } from "react-i18next";
import GallerySection from "./GallerySection";

export default function TryInYourComplexSection() {
  const { t } = useTranslation();

  return (
    <section
      className="relative overflow-hidden bg-gradient-to-b from-slate-50 via-white to-white py-14 sm:py-16 md:py-24"
      aria-labelledby="gallery-section-heading"
    >
      {/* subtle grid + accent */}
      <div
        className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,#e2e8f0_1px,transparent_1px),linear-gradient(to_bottom,#e2e8f0_1px,transparent_1px)] [background-size:4rem_4rem] opacity-[0.35]"
        aria-hidden
      />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary/25 to-transparent" aria-hidden />

      <div className="relative mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="mx-auto mb-10 max-w-3xl text-center sm:mb-12 md:mb-14">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.28em] text-primary/90 sm:text-sm">
            {t("gallery.eyebrow")}
          </p>
          <h2
            id="gallery-section-heading"
            className="text-balance text-2xl font-black tracking-tight text-slate-900 sm:text-3xl md:text-4xl md:leading-[1.15]"
            suppressHydrationWarning
          >
            {t("tryInYourComplex.title")}
          </h2>
          <div className="mx-auto mt-5 h-1 w-16 rounded-full bg-gradient-to-r from-primary/40 via-primary to-primary/40" aria-hidden />
          <p
            className="mx-auto mt-6 max-w-2xl text-pretty text-base leading-relaxed text-slate-600 sm:text-lg"
            suppressHydrationWarning
          >
            {t("tryInYourComplex.subtitle")}
          </p>
        </div>

        <GallerySection />
      </div>
    </section>
  );
}
